import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Fuel level tab body (SWOOP-162), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/fuel-level`. Permission gating (`vehicles:list`) is inherited from the
 * layout route's `beforeLoad`; the page itself redirects fully-electric vehicles (no fuel tank) back to
 * Overview.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/fuel-level')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-fuel-level-page')),
  staticData: { titleKey: 'vehicleFuelLevel' },
});
